export default "__VITE_ASSET__DrAZi110__"